import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import {
  MissingOnboardingProfileField,
  MissingOnboardingStep,
  MissingOnboardingStepKey,
} from '../home.viewModel';

const stepLabels: Record<MissingOnboardingStepKey, string> = {
  profile: 'Complete your profile',
  paymentMethod: 'Add a payment method',
  collectionPublished: "Create at least one offer (make sure it's published)",
};

const profileFieldLabels: Record<MissingOnboardingProfileField, string> = {
  firstName: 'First name',
  lastName: 'Last name',
  email: 'Email',
  title: 'Title',
  instagram: 'Instagram',
  profileLink: 'Profile link',
  avatar: 'Avatar',
};

type GoLiveRequirementsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  missingSteps: MissingOnboardingStep[];
};

export const GoLiveRequirementsModal = ({
  isOpen,
  onClose,
  missingSteps,
}: GoLiveRequirementsModalProps) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    modalClassName="w-full md:w-[480px]"
    modalContentClassName="!overflow-visible !flex-none"
    title="Before you can go live"
    description="Finish these steps to unlock the Go live button:"
    primaryCta={{ caption: 'Got it', onClick: onClose }}
  >
    <ul className="flex flex-col gap-3 m-0 p-0 list-none">
      {missingSteps.map((step) => (
        <li key={step.key} className="flex flex-col gap-2">
          <div className="flex items-start gap-3">
            <FontAwesomeIcon
              icon={faCircleExclamation}
              className={sprinkles({ color: 'WARNING-900' })}
            />
            <Typography variant="body" size="medium" color="N-100">
              {stepLabels[step.key]}
            </Typography>
          </div>
          {step.subItems && step.subItems.length > 0 && (
            <ul className="flex flex-col gap-1 ml-8 list-disc pl-4">
              {step.subItems.map((sub) => (
                <li key={sub}>
                  <Typography variant="body" size="small" color="N-80">
                    {profileFieldLabels[sub]}
                  </Typography>
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  </Modal>
);
